/* eslint-disable import/prefer-default-export */
import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import NodePort from '@appblocks/codegeneration/Nodes/NodePort';
import NodeParameter from '@appblocks/codegeneration/Nodes/NodeParameter';


export const getCodeBlocks = (feature: BaseFeature): CodeBlock[] => {
    const blocks: Array<CodeBlock> = [];

    blocks.push({
        location: 'FUNCTION_DEFINITIONS',
        blockType: BlockType.LOCATION,
        id: 'callback_mqtt_connect_ok',
        template: `
function callback_mqtt_connect_ok(){
    /****callback_mqtt_connect_ok****/
}`,
    });

    blocks.push({
        location: 'FUNCTION_DEFINITIONS',
        blockType: BlockType.LOCATION,
        id: 'callback_mqtt_notif',
        template: `
function callback_mqtt_notif(topic, data){
    /****callback_mqtt_notif****/
}`,
    });

    return blocks;
};
